import { viewConstants } from './view.constants';

import { store } from 'react-notifications-component';


export function notification ( props ) { 
    if (!props) props = {}
    store.addNotification({
      title: props.title,
      message: props.message?props.message:'no message',
      type: props.type?props.type:"success",
      insert: "top",
      container: "bottom-left",
      animationIn: ["animate__animated", "animate__fadeIn"],
      animationOut: ["animate__animated", "animate__fadeOut"],
      dismiss: {
        duration: 3000,
        onScreen: true
      }
    });
  }



export function isLoadingModule( module, bool ) {
    return {
        module: module,
        type: bool?viewConstants.IS_LOADING:viewConstants.IS_NOT_LOADING 
     }
}

export function isLoading( bool ) {
    return {
        type: bool?viewConstants.IS_LOADING:viewConstants.IS_NOT_LOADING 
     }
}

export function setBreadCrumb ( breadCrumb, activeTitle ) {
  return {
      type: viewConstants.SET_BREADCRUMB,
      breadCrumb: breadCrumb,
      activeTitle: activeTitle
  }
}

export function setMainTitle ( title, menu ) {
    return {
        type: viewConstants.SET_MAIN_TITLE,
        mainTitle: title,
        contextDropMenu: menu 
    }
}

export function setContextDropMenu ( menu ) {
    return {
        type: viewConstants.SET_CONTEXT_DROP_MENU,
       contextDropMenu: menu 
    }
}
